import { render, staticRenderFns } from "./ConfirmNewIp.vue?vue&type=template&id=534285da&"
import script from "./ConfirmNewIp.vue?vue&type=script&lang=js&"
export * from "./ConfirmNewIp.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmNewIp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports